const getCurrencySymbol = (projectCurrencySymbol, selectedAmountField) =>
  ['total.amountCalculated', 'total.amountCalculatedNet'].includes(selectedAmountField)
    ? '$'
    : projectCurrencySymbol;

export default getCurrencySymbol;
